import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isMobile } from "../utils";

interface UtilsState {
  menuOpen: boolean;
  isMobile: boolean;
  popUp: {
    open: boolean;
    type: string;
    message: string;
    callback?: () => void;
  };
  upgradeModalOpen: boolean;
  authPromptOpen: boolean;
}

const initialState: UtilsState = {
  menuOpen: false,
  isMobile: isMobile(),
  popUp: {
    open: false,
    type: "",
    message: "",
  },
  upgradeModalOpen: false,
  authPromptOpen: false,
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    openMainMenu: (state) => {
      state.menuOpen = true;
    },
    closeMainMenu: (state) => {
      state.menuOpen = false;
    },
    toggleMainMenu: (state) => {
      state.menuOpen = !state.menuOpen;
    },
    togglePopup: (
      state,
      action: PayloadAction<{
        open?: boolean;
        type?: string;
        message?: string;
        callback?: () => void;
      }>
    ) => {
      const shouldOpen = action.payload.open ?? !state.popUp.open;
      if (shouldOpen) {
        state.popUp.open = true;
        state.popUp.type = action.payload.type || "";
        state.popUp.message = action.payload.message || "";
        state.popUp.callback = action.payload.callback;
      } else {
        state.popUp.open = false;
        state.popUp.type = "";
        state.popUp.message = "";
        state.popUp.callback = undefined;
      }
    },
    setUpgradeModalOpen: (state, action: PayloadAction<boolean>) => {
      state.upgradeModalOpen = action.payload;
    },
    setAuthPromptOpen: (state, action: PayloadAction<boolean>) => {
      state.authPromptOpen = action.payload;
    },
  },
});

// Export actions
export const { openMainMenu, closeMainMenu, toggleMainMenu, togglePopup, setUpgradeModalOpen, setAuthPromptOpen } =
  utilsSlice.actions;

// Export reducer
export default utilsSlice.reducer;
